<template>
  <HirePageHeader :hire-id="hireId" />
  <WdsTabs :initial-active-tab-key="props.tab">
    <WdsTab :title="$t('Overview')" tab-key="overview">
      <div class="tw-mt-4">
        <HirePageOverview :hire-id="hireId" />
      </div>
    </WdsTab>
    <WdsTab v-if="approvalApprovablesCount > 0" :title="$t('Approvals')" tab-key="approvals">
      <div class="tw-mt-4">
        <ApprovalOverviewPage :hire-id="hireId" />
      </div>
    </WdsTab>
  </WdsTabs>
</template>

<script lang="ts" setup>
import { WdsTabs, WdsTab } from '@worksome/wds-components'
import { useQuery } from '@vue/apollo-composable'
import { computed } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import HirePageHeader from '@/components/Hire/HirePageHeader.vue'
import ApprovalOverviewPage from '@/components/Workflows/Approvals/Triggers/Hire/ApprovalOverviewPage.vue'
import HirePageOverview from '@/components/Hire/HirePageOverview.vue'
import { graphql } from '@/gql'

interface Props {
  hireId: string
  tab?: string
}

const props = withDefaults(defineProps<Props>(), {
  tab: 'overview',
})

const { result } = useQuery(
  graphql(`
    query ApprovalApprovablesResult($approvable: ID!, $first: Int) {
      approvalApprovables(approvable: $approvable, first: $first) {
        data {
          id
        }
      }
    }
  `),
  {
    approvable: props.hireId,
    first: 10,
  },
  {
    clientId: 'publicApiCustomFields',
  },
)

const approvalApprovablesCount = computed(() => result.value?.approvalApprovables.data.length ?? 0)
</script>
